export function getSeriesBy(prop, value, series) {
    return series.find((s) => s[prop] === value);
}
export function getThreshold(name, series) {
    var _a;
    return (_a = series.thresholds) === null || _a === void 0 ? void 0 : _a.find((t) => t.type === name);
}
export function getAlertsSeriesId() {
    return "speedcurve_alerts";
}
export function getDeploysSeriesId() {
    return "speedcurve_deploys";
}
export function getNotesSeriesId() {
    return "speedcurve_notes";
}
export function getNotesXAxisId() {
    return "speedcurve_notes_xaxis";
}
/**
 * Generate identifiers for a series' rate of change thresholds.
 */
export function getRateOfChangeThresholdSeriesIds(series) {
    return [`speedcurve_roc_lower_${series.name}`, `speedcurve_roc_upper_${series.name}`];
}
/**
 * Get the x-axis bounds from an array of series. The bounds are returned as milliseconds since epoch.
 *
 * @return [number, number]
 */
export function getXAxisBoundsFromSeries(series) {
    const startTimes = series.map((s) => s.startTime).filter(Boolean);
    const endTimes = series.map((s) => s.endTime).filter(Boolean);
    return [Math.min(...startTimes) * 1000, Math.max(...endTimes) * 1000];
}
